import {Component, ReactNode} from 'react';
import './SilhouettePopup.scss';
import {
    Container,
    Dialog, DialogContent,
    DialogTitle,
    IconButton
} from '@mui/material';
import {GameContext} from '../content/GameContext';
import {Close} from '@mui/icons-material';

export interface SilhouettePopupProps<Schema> {
    show: boolean;
    onClose: () => void;
    gameContext: GameContext<Schema>;
}

export class SilhouettePopup<Schema> extends Component<SilhouettePopupProps<Schema>> {

    override render(): ReactNode {
        const image = this.props.gameContext.getActualResultInformation()[1];
        return <Dialog
            open={this.props.show}
        >
            <Container>
                <DialogTitle>
                    <IconButton aria-label="close" onClick={this.props.onClose} sx={{
                        position: 'absolute',
                        right: 4,
                        top: 4,
                        color: "primary.main"
                    }}>
                        <Close/>
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <img
                        src={image}
                        alt="?"
                        style={{
                            userSelect: "none", pointerEvents: "none",
                            minHeight: "240px",
                            minWidth: "240px",
                            objectFit: "fill",
                            filter: "brightness(0)",
                            transition: "filter .3s"
                        }}
                        title={"Silhouette"}
                    />
                </DialogContent>
            </Container>
        </Dialog>;
    }
}
